import React from 'react';
import './Home.css'; // Custom styles

const Home = () => {
  return (
    <div 
      className="main-wrapper"
      style={{ 
        "--desktop-background": "url(/assets/Background.png)",
        "--mobile-background": "url(/assets/splashScreen.png)"
      }}
    >
      <div className="home-content">
        <div className="d-flex justify-content-center">
          <img className="logo" src="/assets/tran_logo.svg" alt="Logo" />
        </div>
        <p className="app-heading">
          To Love is to create a LifeWink.
          <br />
          To be Loved is to receive a LifeWink.
        </p>
        <p className="app-sideheading desktop-text">
          LifeWink carries forth the greatest gifts we have in life <br /> — to love and be loved — <br /> LifeWink will inspire new conversations, behaviors and experiences worldwide while <br /> stirring the way people think, feel and do.
        </p>
        <p className="app-sideheading mobile-text">
          LifeWink carries forth the greatest gifts we have in life <br /> — to love and be loved — <br /> LifeWink will inspire new conversations, behaviors and experiences worldwide while <br /> stirring the way people think, feel and do.
        </p>
        
        {/* Desktop Container Image */}
        <div style={{ position: "relative", width: "100%", height: "100%" }} className="desktop-image">
          <img
            className="container-image"
            src="/assets/container_2.png"
            alt="Container"
            loading="lazy"
            style={{ display: "block", width: "90%", margin: "100px auto 80px auto", position: "relative", zIndex: 2, maxWidth: "1260px" }}
          />
        </div>
        
        {/* Mobile Images */}
        <img
          className="mobile-image-1"
          src="/assets/mobile_container_1.png"
          alt="Mobile Image 1"
          loading="lazy"
        />
        <img
          className="mobile-image-2"
          src="/assets/mobile_container_2.png"
          alt="Mobile Image 2"
          loading="lazy"
        />
        
        {/* Coming Soon Section */}
        <div className="coming-soon-section">
          <h1 className="coming-soon-title">Coming Soon</h1>
          <p className="coming-soon-subtitle">We are launching soon. Stay tuned.</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
